import { render } from "./HeroiconsOutlineFingerPrint.vue?vue&type=template&id=f7b1c226"
const script = {}

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__